"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { MegaMenuSection } from "@/components/layout/navigation/MegaMenuSection";
import { MegaMenuFeaturedCard } from "@/components/layout/navigation/MegaMenuFeaturedCard";
import { MegaMenuBottomStrip } from "@/components/layout/navigation/MegaMenuBottomStrip";
import type { MegaMenuConfig } from "@/lib/navigation";
interface MegaMenuPanelProps {
  config: MegaMenuConfig;
  onClose: () => void;
}

/** Static class names, so Tailwind sees each one: one equal column per section (and card). */
const SHELF_COLUMNS: Record<number, string> = {
  1: "grid-cols-1 gap-12",
  2: "grid-cols-2 gap-12",
  3: "grid-cols-3 gap-12",
  4: "grid-cols-4 gap-10"
};
export function MegaMenuPanel(t0) {
  const $ = _c(26);
  const {
    config,
    onClose
  } = t0;
  const isDropdown = config.layout === "dropdown";
  const columns = config.sections.length + (config.featuredCard ? 1 : 0);
  const t1 = isDropdown ? "p-3" : "max-w-[1280px] mx-auto px-20 pt-10 pb-9";
  const t2 = isDropdown ? "grid-cols-1" : SHELF_COLUMNS[columns];
  let t3;
  if ($[0] !== t2) {
    t3 = cn("grid", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== config.sections || $[3] !== isDropdown || $[4] !== onClose) {
    let t5;
    if ($[6] !== isDropdown || $[7] !== onClose) {
      t5 = section => <MegaMenuSection key={section.id} section={section} onItemClick={onClose} compact={isDropdown} />;
      $[6] = isDropdown;
      $[7] = onClose;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = config.sections.map(t5);
    $[2] = config.sections;
    $[3] = isDropdown;
    $[4] = onClose;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[9] !== config.featuredCard || $[10] !== onClose) {
    t5 = config.featuredCard && <MegaMenuFeaturedCard card={config.featuredCard} onClose={onClose} />;
    $[9] = config.featuredCard;
    $[10] = onClose;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t1 || $[17] !== t6) {
    t7 = <div className={t1}>{t6}</div>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== config.bottomStrip || $[20] !== isDropdown || $[21] !== onClose) {
    t8 = config.bottomStrip && <MegaMenuBottomStrip strip={config.bottomStrip} stacked={isDropdown} onClose={onClose} />;
    $[19] = config.bottomStrip;
    $[20] = isDropdown;
    $[21] = onClose;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}